<div class="row banner task-amend">
    <div class="col">
        <h6 class="pt-5px"><strong>Update dropdown lists
            </strong></h6>
    </div>
    <div class="col">
        <button (click)="createLookup()" class="btn btn-secondary float-end" *ngIf="canCreate">
            Create new
        </button>
    </div>
    <!-- *ngIf="!canSave" -->
</div>

<form [formGroup]="lookupTypes" class="search">
    <div class="d-flex justify-content-start">
        <div class="m-0 mr-3 w-35">
            <ng-select (change)="getLookupData($event)" [items]="lktypes" formControlName="lookupType"
                bindLabel="displayText" [placeholder]="'Drop down type'">
            </ng-select>
        </div>
    </div>
</form>

<div class="table-responsive-sm" *ngIf="dataWithFilter.lookupFields.length>0">
    <table class="table table-bordered">
        <tr>
            <th>Value</th>
            <th>Display text</th>
            <th>Order</th>
            <th>Is drop down active ? </th>
            <th>Action</th>
        </tr>

        <tr *ngFor="let lookup of dataWithFilter.lookupFields">
            <td>{{lookup.value}} </td>
            <td>{{lookup.displayText}} </td>
            <td>{{lookup.order }}</td>
            <td>
                <div class="activity-icon activity-{{lookup.isActive}}"></div>
            </td>
            <td>
                <img class="cursor-pointer" title="Edit look up" (click)="editlookup(lookup)" *ngIf="isEditable"
                    src="design/images/edit.png" />
            </td>
        </tr>
    </table>
</div>
<div *ngIf="dataWithFilter.lookupFields.length==0" class="row p-3">
    <div class="col text-center text-dark">
        <p class="h6 font-weight-bold text-muted">No drop down fields to show!</p>
    </div>
</div>



<div class="row" *ngIf="dataWithFilter.lookupFields.length>0">
    <div class="col-xs-10 col-10">
        <pagination [totalItems]="dataWithFilter.sortParameters.totalRecords" [boundaryLinks]="true"
            previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
            [itemsPerPage]="dataWithFilter.sortParameters.itemsPerPage" [maxSize]="5" [(ngModel)]="currentPage"
            (pageChanged)="pageChanged($event)"></pagination>
    </div>

    <div class="col-xs-2 col-2">
        <select (change)="onSelectChanges()" [(ngModel)]="dataWithFilter.sortParameters.itemsPerPage"
            class="form-control form-control-sm">
            <option *ngFor="let count of changeCount" [value]="count">{{count}}</option>
        </select>
        <p>Per page</p>
    </div>

</div>